import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
const APP_AUTH_ME = process.env.VUE_APP_AUTH_ME

export default new Vuex.Store({
    state: {
        dimension: [],
        filter: {},
        menu: [],
        modul: '-',
        redirectPath:'',
        prevRoute: {},
        notifObj: {TaskCount:0,MrCount:0,PrCount:0,RcvCount:0},
        notifications:[],
        taskcount: 0,
        user: {},
        cart: { display: 0, items: [], cartOwner: '' }
    },
    mutations: {
        dimension(state, value) {
            state.dimension = value;
        },
        filter(state, value) {
            state.filter = value;
        },
        opiCbyae(state, value) {
            // state.opiCbyae = value;
            // state.commit("opiCbyae", value);
            localStorage.setItem("opiCbyae", value);
        },
        opiDbyae(state, value) {
            // state.opiDbyae = value;
            // state.commit("opiDbyae", value);
            localStorage.setItem("opiDbyae", value);
        },
        SoMenu(state, value) {
            localStorage.setItem("SoMenu", value);
        },
        SoRevMenu(state, value) {
            localStorage.setItem("SoRevMenu", value);
        },
        modul(state, value) {
            state.modul = value;
        },
        redirectPath(state, value) {
            state.redirectPath = value;
        },
        menu(state, value) {
            state.menu = value;
        },
        notifObj(state, value) {
            state.notifObj = value;
        },
        prevRoute(state, value) {
            state.prevRoute = value;
        },
        taskcount(state, value) {
            state.taskcount = value;
        },
        user(state, value) {
            state.user = value;
            // save to local storage
            localStorage.setItem(APP_AUTH_ME, JSON.stringify(value))
        },
        addToCart(state, value) {
            state.cart.items.push(value);
            localStorage.setItem('cart', JSON.stringify(state.cart));
        },
        changeCartOwner(state, value) {
            // console.log('cartOwner : ', value);
            state.cart.cartOwner=value;
            localStorage.setItem('cart', JSON.stringify(state.cart));
        },
    },
    actions: {
        "SOCKET_accountingperiodeclose"(state, value) {
            const user = this.state.user;
            user.tglaktif=value;
            // const me = await auth.current();
            // state.commit("user", me);
            state.commit("user", user);
            console.log('Periode Accounting : ', value);
            console.log('user : ', this.state.user);
        },
        "SOCKET_koranperiodeclose"(state, value) {
            const user = this.state.user;
            user.tglkoran = value;
            state.commit("user", user);
            console.log('Socket Periode Koran : ', value);
            console.log('user : ', this.state.user);
        },
        "SOCKET_notificationcounter"(state, value) {
            // console.log('VUEX ACTION, notificationcounter Update from socket', value);
            const myNotif = (value || []).reduce((newArr, item) => {
                if ((item.username === this.state.user.username) && (item.compcode === this.state.user.compcode) && (item.notifName)) {
                    newArr.push(item);
                }
                return newArr;
            }, []);
            this.state.notifications = myNotif;
        },
        "SOCKET_opentaskcount"(state, value) {
            console.log('VUEX ACTION, taskCount Update from socket', value);
            const _selected = this.state.notifications.find(r => r.notifname === 'Pending Task');
            const myNotif = value.find(r => r.username === this.state.user.username);
            if (myNotif) {
                if (_selected){
                    _selected.counter = myNotif.jumlah;
                } else {
                    this.state.notifications.push({ notifname: 'Pending Task', routerName: 'app.task', counter: myNotif.jumlah })
                }
            } else if (_selected) {
                _selected.counter = 0;
            }
        },
        "SOCKET_mrnotif"(state, value) {
            const _selected = this.state.notifications.find(r => r.notifname === 'Material Request');
            const myNotif = value.find(r => r.username === this.state.user.username);
            if (myNotif) {
                if (_selected) {
                    _selected.counter = myNotif.jumlah;
                } else {
                    this.state.notifications.push({ notifname: 'Material Request', routerName: 'logistic.mr', counter: myNotif.jumlah })
                }
            } else if (_selected) {
                _selected.counter = 0;
            }
        },
        "SOCKET_mrclosednotif"(state, value) {
            const _selected = this.state.notifications.find(r => r.notifname === 'MR Items Closed');
            const myNotif = value.find(r => r.username === this.state.user.username);
            if (myNotif) {
                if (_selected) {
                    _selected.counter = myNotif.jumlah;
                } else {
                    this.state.notifications.push({ notifname: 'MR Items Closed', routerName: 'app.requisition', counter: myNotif.jumlah })
                }
            } else if (_selected) {
                _selected.counter = 0;
            }
        },
        "SOCKET_prnotif"(state, value) {
            const _selected = this.state.notifications.find(r => r.notifname === 'Purchase Request');
            const myNotif = value.find(r => r.username === this.state.user.username);
            if (myNotif) {
                if (_selected) {
                    _selected.counter = myNotif.jumlah;
                } else {
                    this.state.notifications.push({ notifname: 'Purchase Request', routerName: 'procurement.requisition', counter: myNotif.jumlah })
                }
            } else if (_selected) {
                _selected.counter = 0;
            }
        },
        "SOCKET_prclosednotif"(state, value) {
            const _selected = this.state.notifications.find(r => r.notifname === 'PR Items Rejected');
            const myNotif = value.find(r => r.username === this.state.user.username);
            if (myNotif) {
                if (_selected) {
                    _selected.counter = myNotif.jumlah;
                } else {
                    this.state.notifications.push({ notifname: 'PR Items Rejected', routerName: 'logistic.pr', counter: myNotif.jumlah })
                }
            } else if (_selected) {
                _selected.counter = 0;
            }
        },
        "SOCKET_rcvnotif"(state, value) {
            const _selected = this.state.notifications.find(r => r.notifname === 'UnPosted Receiving');
            const myNotif = value.find(r => r.username === this.state.user.username);
            if (myNotif) {
                if (_selected) {
                    _selected.counter = myNotif.jumlah;
                } else {
                    this.state.notifications.push({ notifname: 'UnPosted Receiving', routerName: 'procurement.receiving', counter: myNotif.jumlah })
                }
            } else if (_selected) {
                _selected.counter = 0;
            }

        }

    }
})
